import { render } from "./ItemsList.vue?vue&type=template&id=311a29fe&scoped=true"
import script from "./ItemsList.vue?vue&type=script&lang=js"
export * from "./ItemsList.vue?vue&type=script&lang=js"

import "./ItemsList.vue?vue&type=style&index=0&id=311a29fe&lang=scss&scoped=true"

import exportComponent from "/opt/project/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-311a29fe"]])

export default __exports__